import { Component, forwardRef, Input } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable } from 'rxjs';
import { AltriSoggettiComponent } from 'src/app/anagrafiche/altri-soggetti/altri-soggetti.component';
import { ExternalSelectorComponent } from '../../external-selector/external-selector.component';

@Component({
  providers: [
    { provide: MatFormFieldControl, useExisting: forwardRef(() => AltroSoggettoPickerComponent) },
  ],
  selector: 'altro-soggetto-picker',
  templateUrl: '../../external-selector/external-selector.component.html',
  styleUrls: ['../../external-selector/external-selector.component.scss']
})
export class AltroSoggettoPickerComponent extends ExternalSelectorComponent {

  @Input()
  get externalEntityObserver(): Observable<any> {
    return this.dialog.open(AltriSoggettiComponent, {
      data: {
        selectionMode: true,
        defaultSearch: this.defaultSearch,
      }
    }).afterClosed();
  };

  getRoute = (id) => `/altri-soggetti/${id}`;

}
